import { map } from 'ramda'

import { Rights } from 'app/common/constants/rights'

import { allGranted } from './allGranted'


export const onlyRead: Rights = map<any, any>(map(() => ({ read: true, edit: false })), allGranted)
